jQuery(document).ready(function($) {
  $('html').on('click', '#search-toggle', function() {
    if ($(this).find('span').hasClass('fa-search')) {
      $('#search').focus();
    }
	$('.jd-main-search #search').show();
    $('.jd-main-search').toggleClass('jd-active');

    if($(this).hasClass('jd-btn-search-active')){
      $(this).html('<svg xmlns="http://www.w3.org/2000/svg" width="16.501" height="16.546" viewBox="0 0 16.501 16.546"> <g transform="translate(0.25 0.25)"> <g id="Icon-Set"> <path id="search" d="M262.732,1151.229a5.6,5.6,0,1,1,5.7-5.6,5.648,5.648,0,0,1-5.7,5.6Zm9.117,2.9-4.131-4.066a6.526,6.526,0,0,0,1.746-4.436,6.733,6.733,0,1,0-6.732,6.622,6.762,6.762,0,0,0,4.237-1.48l4.147,4.081a.521.521,0,0,0,.732,0,.5.5,0,0,0,0-.72Z" transform="translate(-256 -1139)" stroke="#000" stroke-width="0.5" fill-rule="evenodd"/> </g> </g> </svg>');
      $(this).removeClass('jd-btn-search-active');
    }else{
      $(this).html('<svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.459" viewBox="0 0 17.368 16.459"> <g id="Group_163" data-name="Group 163" transform="translate(-1700.816 -67.77)"> <line id="Line_26" data-name="Line 26" x1="16" y2="15" transform="translate(1701.5 68.5)" fill="none" stroke="#000" stroke-width="2"/> <line id="Line_27" data-name="Line 27" x2="16" y2="15" transform="translate(1701.5 68.5)" fill="none" stroke="#000" stroke-width="2"/> </g></svg>');
      $(this).addClass('jd-btn-search-active');
      $('#search').focus();
    }
  });
  
  /*var url = new URL(window.location.href);
  var sku = url.searchParams.get("sku");
  if(sku && sku == "true"){
  	jQuery("div.sku").show();
  }*/
  
  
  /* JUNAID MM-MENU BEGIN */
  
  const menu = new Mmenu( "#ma-mobile-header-nav", {
  	// nothing here
  },{
    openingInterval: 0, // default 25
    transitionDuration: 0, // default 400
  });

  $(".dropdown.has_sub_menu.anklets").replaceWith('<li class="anklets"><a href="' + Shopify.routes.root +'collections/anklets">Anklets</a></li>');
  
  jQuery(".mm-close-menu").on("click", function(e){
    e.preventDefault();
    // Get the API
    const api = menu.API;
    // Invoke a method
	menu.close();
    //api.closeAllPanels( );
    jQuery("img.back-mm").hide();
     jQuery("img.cross-mm").show();
    jQuery(".mobile--btn-sm a, .mobile--btn-sm button").removeClass("mm-back-menu");
    jQuery(".mobile-nav").removeClass("go");
  });
   jQuery(".mm-back-menu, .go-back-mm, div#mm-1 a.mm-navbar__title").on("click", function(e){
    e.preventDefault();
     jQuery(".mobile--btn-sm a, .mobile--btn-sm button").addClass("mm-close-menu");
     // Get the API
     const api = menu.API;
     jQuery("img.back-mm").hide();
     jQuery("img.cross-mm").show();
     jQuery(".go-back-mm").removeClass("showw");
     api.closeAllPanels( );
   });
  jQuery("li.has_sub_menu.mm-listitem").on("click", function(){
      jQuery("img.cross-mm").hide();
      jQuery("img.back-mm").hide();
      jQuery(".mobile--btn-sm a, .mobile--btn-sm button").removeClass("mm-close-menu");
      jQuery(".mobile--btn-sm a, .mobile--btn-sm button").addClass("mm-back-menu");
      jQuery(".go-back-mm").addClass("showw");
  });
  
  // Trigger sub menu 
  jQuery("a.mm-btn.mm-btn_next.mm-listitem__btn.mm-listitem__text a").on("click", function(e){
    e.preventDefault();
  	jQuery(this).parent().children(".mm-sronly").trigger("click");
  });

  // ADD THE NAVI PROMO IMAGE AND LOYALTY AND SIGN IN LINKS TO THE MOBILE MENU
  
  // if(typeof $(".header-wrapper").data("mobile-promo-banner") !== 'undefined' && $(".header-wrapper").data("mobile-promo-banner").length && typeof $(".header-wrapper").data("mobile-promo-banner-link") !== 'undefined' && $(".header-wrapper").data("mobile-promo-banner-link").length){
  //   $("#custom-nav").append("<div id='jd-mobile-navi-promo'><a href='"+ $(".header-wrapper").data("mobile-promo-banner-link") +"'><img src='"+ $(".header-wrapper").data("mobile-promo-banner") +"' alt='Adina Eden' /></a></div>");
  // }
  // $("#custom-nav").append("<div id='jd-mobile-navi-misc-links'><a href='"+window.Shopify.routes.root.replace(/\/$/, "")+"/pages/loyalty-program'>Loyalty</a><a href='"+window.Shopify.routes.root.replace(/\/$/, "")+"/account/login'>Sign in</a></div>");


  // var loyaltyInMenu = $("#custom-nav .sale.mm-listitem").clone().removeClass("sale").addClass("loyalty-program");
  // $(loyaltyInMenu).find("a").attr("href", "/pages/loyalty-program").text("Loyalty Program");
  // $(loyaltyInMenu).appendTo("#custom-nav ul");
  
  /* JUNAID MM-MENU END */
  
  /*$("li.summer-jewelry > a").html(function(index, html) {
    return html.replace(/\S/g, '<span>$&</span>');
  });*/
  
  /* JUNAID BACK TO TOP BUTTON BEGIN */

  //Get the button
  var mybutton = document.getElementById("jd-scroll-to-top");

  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function() {jdScrollFunction()};

  function jdScrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      jQuery(mybutton).fadeIn();
    } else {
      jQuery(mybutton).fadeOut();
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  jQuery("#jd-scroll-to-top").click(function(){
    jQuery("html, body").animate({ scrollTop: "0" }, 500);
  });
  
  /* A11y */
  $(".dropdown.has_sub_menu .menu--parent-link button").click(function() {
    let linked_class = $(this).attr('class');
    let currently_open = $(".dropdown.has_sub_menu." + linked_class).hasClass('open');
    $(".dropdown.has_sub_menu").removeClass('open');
    $(".nav-indicator").text("+");
    if (true !== currently_open) {
      $(".dropdown.has_sub_menu").attr('aria-expanded', 'false');
      $(".nav-indicator", this).text("-");
      $(".dropdown.has_sub_menu." + linked_class).addClass('open');
      $(".dropdown.has_sub_menu." + linked_class).attr('aria-expanded', 'true');
      $(".dropdown.has_sub_menu." + linked_class).parent().attr('data-is-expanded', 'true');
    } else {
      $(".dropdown.has_sub_menu." + linked_class).attr('aria-expanded', 'false');
      $(".dropdown.has_sub_menu." + linked_class).parent().attr('data-is-expanded', 'false');
    }
  });
  
  function a11y_fix_product(){
    $(".nosto-slideout-bundle-container .nosto-bundle-list .swatch-element.color label").each(function() {
      let labelName = $(this).attr('title');
      $(this).html("<span class='sr-only'>" + labelName.replace('swatch-color-', '') + "</span>");
    });
    $("#mobile-product .ThumbGallery .flex-direction-nav").remove();
    $("#variant-inventory input#txtEmailAddress").attr('aria-label', 'Email address');
    $("h1.nosto-bundle-header-title").replaceWith("<h2 class='nosto-bundle-header-title'>" + $("h1.nosto-bundle-header-title").text() + "</h2>");
    $("h4.nosto-bundle-header-subtitle").replaceWith("<h3 class='nosto-bundle-header-subtitle'>" + $("h4.nosto-bundle-header-subtitle").text() + "</h3>");
  };
  
  if ($('body').hasClass('product')) {
    window.setTimeout( a11y_fix_product, 3000 );
  }
  function a11y_fix_wishlist() {
    $("#swym-plugin .swym-modals-container").attr('id', 'swym-wishlist');
    $("a.jdgm-random-link").remove();
  }
  window.setTimeout( a11y_fix_wishlist, 8000);

  //$(".has_sub_menu.ma-link.featured").find(".jd-submenu.jd1").find(".jd-submenu-left, .jd-submenu-right").remove();

  //$(".has_sub_menu.ma-link.featured").find(".jd-submenu.jd1").html('<div id="jd-holiday-menu" style="position: relative;z-index: 2; width: 100%;display: inline-block;vertical-align: top;"> <div class="holiday-menu-flex"> <h3>Featured</h3> <ul> <li><a href="https://adinaeden.com/collections/cocktail-collection">Holiday 2022</a></li><li><a href="https://adinaeden.com/collections/14k-gold?pf_p_price=20.00%3A202.75&sort=created-descending">14K Under $200</a></li><li><a href="https://adinaeden.com/collections/new-arrivals-c97d03">New Arrivals</a></li><li><a href="https://adinaeden.com/collections/best-sellers-c97d03">Best Sellers</a></li><li><a href="https://adinaeden.com/collections/the-garden-of-charms">Charms</a></li><li><a href="https://adinaeden.com/collections/vintage-chains-c97d03">Essentials</a></li></ul> </div><div class="holiday-menu-flex"> <h3 class="jd-holiday-panel-title">The Holiday Gift Shop!</h3> <img src="https://cdn.shopify.com/s/files/1/0901/1466/files/056A9369_116e2ed3-e38f-41ce-8410-df8aab429afa.jpg?v=1667604470" alt="Adina Eden Holiday Gift Shop 2022"> </div><div class="holiday-menu-flex"> <ul> <li><a href="https://adinaeden.com/collections/gifts-under-76">Gifts Under $75</a></li><li><a href="https://adinaeden.com/collections/gifts-under-150">Gifts Under $150</a></li><li><a href="https://adinaeden.com/collections/gifts-under-350">Gifts Under $350</a></li><li><a href="https://adinaeden.com/collections/gifts-500">Gifts Under $500</a></li></ul> </div></div><style>#jd-holiday-menu{display: flex!important;}#jd-holiday-menu > div:nth-child(1){flex-basis: 30%;}#jd-holiday-menu > div:nth-child(2){flex-basis: 50%;}#jd-holiday-menu > div:nth-child(3){flex-basis: 20%;padding-top: 35px;}#jd-holiday-menu > div:nth-child(1) > h3{font-size: 18px;color: #cf0c71;text-transform: uppercase;text-decoration: underline;font-weight: 500;}#jd-holiday-menu > div:nth-child(1) > ul li{display: block;}#jd-holiday-menu > div:nth-child(1) > ul li a{text-align: center!important;}#jd-holiday-menu > div:nth-child(2) > h3{font-size: 22px;text-transform: uppercase;color: #cf0c71;font-weight: 500;}#jd-holiday-menu > div:nth-child(3) ul li{display: block;}#jd-holiday-menu > div:nth-child(3) ul li a{padding: 10px 5px;background: #cf0c71;width: 200px;color: white;margin-bottom: 10px;font-size: 18px!important;text-align: center!important;}</style>');

  //$(".has_sub_menu.ma-link.featured > span.HeadDEsk > a").text("Holiday");

  Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }

  if($(".jd-pdp-edd-js").length){
    var date = new Date();

    var eddData = $(".jd-pdp-edd-js").data("edd");
    eddData = eddData.split(",");
    var eddMin = date.addDays(parseInt(eddData[0]));
    var eddMax = date.addDays(parseInt(eddData[1]));
  
    $(".jd-pdp-edd-js").html(String(eddMin).slice(0, 10) + " - " + String(eddMax).slice(0, 10));
  }


  if($("body").hasClass("product")){
    if(window.innerWidth < 768){
      $("#breadcrumb").addClass("breadcrumb-mobile").prependTo(".product-top");
    }
  }

  

  if($(".product-json").length){
    var productJSON = jQuery.parseJSON($(".product-json").html());
    url = new URL(window.location.href);
    if (url.searchParams.has('variant')) {
      productJSON.variants.forEach(function(currentValue, index){
        if(currentValue.id == url.searchParams.get("variant")){
          if($("#jd-upc").length){
              $("#jd-upc").text("UPC: "+currentValue.barcode);
          } else {
              $("#acc-cont-product-details").find("ul").append("<li id='jd-upc'>UPC: "+ currentValue.barcode +"</li>")
          }
        }
      });
    } else {
      productJSON.variants.forEach(function(currentValue, index){
        if(currentValue.available == true){
          if($("#jd-upc").length){
              return false;
          } else {
              $("#acc-cont-product-details").find("ul").append("<li id='jd-upc'>UPC: "+ currentValue.barcode +"</li>")
          }
        }
      });
    }
    
    window.addEventListener('jdVariantChanged', (e) => {
      if($("#jd-upc").length){
          $("#jd-upc").text("UPC: "+e.detail.barcode);
      } else {
          $("#acc-cont-product-details").find("ul").append("<li id='jd-upc'>UPC: "+ e.detail.barcode +"</li>")
      }
    }, false);
  }


  if ($("body").hasClass("collection")) {
    const $container = $('.rte.boost-pfs-filter-collection-description');
    const $button = $container.find('.read-more-button');
    const collapsedHeight = window.innerWidth <= 768 ? 250 : 110;
    const expandedHeight = 2000;
  
    if ($container[0].scrollHeight > collapsedHeight) {
      $button.show();
      $container.css('max-height', collapsedHeight + 'px');
  
      $button.on('click', function () {
        const isExpanded = $container.hasClass('boost-expanded');
  
        if (isExpanded) {
          $container
            .removeClass('boost-expanded')
            .animate({ maxHeight: collapsedHeight }, 400);
          $button.text('Read More');
        } else {
          $container
            .addClass('boost-expanded')
            .animate({ maxHeight: expandedHeight }, 400);
          $button.text('Read Less');
        }
      });
    }
  }





  
  // document.getElementById("hello").innerHTML = "<div class='jd-countdown'><div class='jd-countdown-text'><a href='/collections/new-arrivals'><span class='jd-an-text'>1 Year Anniversary of Adina Eden!</span><br><span class='jd-ti-text'><b>SAVE 45% OFF SITEWIDE!!</b></span></a></div></div>";
  // $("#hello-mobile").remove();
  // $("#hello").removeClass("tablet-hide").removeClass("mobile-hide");


  var statusATC = false;
  document.addEventListener('status:cart:add', (event) => {
    statusATC = true;
  });

  document.addEventListener('status:widget:close', (event) => {
    if(statusATC == true){
      const statusOpenCart = new Event('jdPSOCart');
      document.dispatchEvent(statusOpenCart);
    }
    statusATC = false;
  });

});

window.jdImageZoomer = function(image) {
  var img = new Image(),
  $canvas = $("<canvas>"),
  canvas = $canvas[0],
  context;

  img.crossOrigin = "anonymous";
  img.onload = function() {
    $canvas.attr({
      width: this.width,
      height: this.height
    });
    context = canvas.getContext("2d");
    if (context) {
      context.drawImage(this, 0, 0);
      var finalImage = removeBlanks(this.width, this.height, context, canvas);
      //console.log(finalImage);
      //$(image).attr("src", finalImage.newURL).removeAttr("srcset");
      $(image).css("transition", "transform 0.2s ease").css('transform', 'scale(' + finalImage.scalePercentage + ')');
      $(image).parent().css("background-size", finalImage.scalePercentage*100+'%').css("background-position", "center center");
      //console.log($(image), finalImage.cropSize);
    } else {
      console.log('Browser not compatible with dynamic image resizing.');
    }
  };

  // define here an image
  img.src = $(image).get(0).src;
  //console.log(img.src);
}

var removeBlanks = function(imgWidth, imgHeight, context, canvas) {
  var imageData = context.getImageData(0, 0, imgWidth, imgHeight),
    data = imageData.data,
    getRBG = function(x, y) {
      var offset = imgWidth * y + x;
      return {
        red: data[offset * 4],
        green: data[offset * 4 + 1],
        blue: data[offset * 4 + 2],
        opacity: data[offset * 4 + 3]
      };
    },
    isWhite = function(rgb) {
      // many images contain noise, as the white is not a pure #fff white
      return rgb.red > 240 && rgb.green > 240 && rgb.blue > 240;
    },
    scanY = function(fromTop) {
      var offset = fromTop ? 1 : -1;

      // loop through each row
      for (var y = fromTop ? 0 : imgHeight - 1; fromTop ? (y < imgHeight) : (y > -1); y += offset) {

        // loop through each column
        for (var x = 0; x < imgWidth; x++) {
          var rgb = getRBG(x, y);
          if (!isWhite(rgb)) {
            return y;
          }
        }
      }
      return null; // all image is white
    },
    scanX = function(fromLeft) {
      var offset = fromLeft ? 1 : -1;

      // loop through each column
      for (var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {

        // loop through each row
        for (var y = 0; y < imgHeight; y++) {
          var rgb = getRBG(x, y);
          if (!isWhite(rgb)) {
            return x;
          }
        }
      }
      return null; // all image is white
    };

  var cropTop = scanY(true),
    cropBottom = scanY(false),
    cropLeft = scanX(true),
    cropRight = scanX(false),
    cropWidth = cropRight - cropLeft + 10,
    cropHeight = cropBottom - cropTop + 10;

  var $croppedCanvas = $("<canvas>").attr({
    width: cropWidth,
    height: cropHeight
  });
  //console.log("Original: ", imgWidth, imgHeight,"After: ", cropWidth, cropHeight);


  // finally crop the guy
  $croppedCanvas[0].getContext("2d").drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

  var scaleCrop = cropWidth > cropHeight ? cropWidth / imgWidth : cropHeight / imgHeight;

  return {
    newURL: $croppedCanvas[0].toDataURL(),
    scalePercentage: (scaleCrop > 0.5) ? 1 : 1.6,
    cropSize: cropWidth + " " + cropHeight,
  };
};

document.addEventListener('nostoFilterCallback', (e) => {
  console.log("Nosto product filter callback fired!");
  jQuery("#product-loop > div .reveal > .box-ratio").each(function(index, elem) {
    window.jdImageZoomer($(elem).find("img"));
  });
}, false);

/*
(function() {
 var name="nostojs";
 window[name]=window[name]||function(cb){(window[name].q=window[name].q||[]).push(cb);};
})();

nostojs(function(api) {
  api.listen('postrender', function(event) {
    jQuery(".nosto_carousel img").each(function(index, elem) {
      window.jdImageZoomer(elem);
    });
  });
});
*/